__turbopack_context__.v({
  "underline": "styles-module__71-ZgW__underline",
});
